import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11830822"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "mx-4",
  color: "#e0e0e0"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "mx-4",
  color: "#e0e0e0"
}, null, -1))
const _hoisted_3 = { class: "text-body-2 ml-8" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = {
  key: 1,
  class: "text-center mt-10"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Generating your reimbursement claim...", -1))

import { computed, ref } from "vue";
import disclaimers from "@/constants/disclaimers";
import SignaturePad from "../custom/SignaturePad.vue";
import * as rules from "@/utils/rules";
import FormTitle from "../common/FormTItle.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'FinalReview',
  props: {
    modelValue: {},
    claimPdfs: {},
    loading: { type: Boolean },
    showPdfs: { type: Boolean },
    errorGeneratingPdfs: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const signatureDataUrl = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const shouldShowDisclaimers = ref<boolean>(false);

function toggleDisclaimers() {
  shouldShowDisclaimers.value = !shouldShowDisclaimers.value;
}

function getDisclaimersToShow() {
  return shouldShowDisclaimers.value ? disclaimers : [disclaimers[0]];
}

// To do: Add signature

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FormTitle, {
      title: "Review (2/2)",
      description: "Please take a moment to review our disclaimers and acknowledgements."
    }),
    _createVNode(_component_v_card, {
      class: "pa-4 mt-8 border-red background-red",
      variant: "outlined"
    }, {
      prepend: _withCtx(() => [
        _createVNode(_component_v_icon, { color: "orange" }, {
          default: _withCtx(() => [
            _createTextVNode("mdi-alert")
          ]),
          _: 1
        })
      ]),
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("finalReview.insuranceDisclaimer").toUpperCase()), 1)
      ]),
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDisclaimersToShow(), (disclaimer, index) => {
              return (_openBlock(), _createElementBlock("p", {
                key: index,
                class: "text-body-2"
              }, [
                _createElementVNode("b", null, _toDisplayString(disclaimer.state) + ": ", 1),
                _createTextVNode(" " + _toDisplayString(disclaimer.text), 1)
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_actions, { class: "d-flex justify-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, { onClick: toggleDisclaimers }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(shouldShowDisclaimers.value ? "Read less" : "Read more"), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      class: "pa-4 mt-8 border-red background-red",
      variant: "outlined"
    }, {
      prepend: _withCtx(() => [
        _createVNode(_component_v_icon, { color: "orange" }, {
          default: _withCtx(() => [
            _createTextVNode("mdi-alert")
          ]),
          _: 1
        })
      ]),
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("finalReview.acknowledgementTitle").toUpperCase()), 1)
      ]),
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createElementVNode("ol", _hoisted_3, [
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("finalReview.acknowledgement1")), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("finalReview.acknowledgement2")), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.showPdfs && (_ctx.loading || _ctx.claimPdfs.length))
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: "pa-4 mt-8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Generating Pdfs. Loading..."))
                  : _createCommentVNode("", true),
                (_ctx.errorGeneratingPdfs)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Error generating Pdfs"))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claimPdfs, (pdfBase64, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("a", {
                            href: `data:application/pdf;base64,${pdfBase64}`
                          }, " Claim Pdf #" + _toDisplayString(index + 1), 9, _hoisted_7)
                        ]))
                      }), 128))
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(SignaturePad, {
      class: "mt-8",
      modelValue: signatureDataUrl.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((signatureDataUrl).value = $event))
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_v_input, {
        modelValue: signatureDataUrl.value,
        rules: [rules.requiredRule]
      }, null, 8, ["modelValue", "rules"])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_v_progress_circular, {
            color: "primary",
            indeterminate: ""
          }),
          _hoisted_10
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})